import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { ChangeEmailFormType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { updateEmailVerify } from 'services/api/user'
import { Response } from 'utils/fetchApi'

const submit = function* () {
  const form: ChangeEmailFormType = yield select(selectors.changeEmail.getValues)

  yield put(actions.form.change(formName.CHANGE_EMAIL, 'loading', true))

  const data: Response<void> = yield call(updateEmailVerify, {
    code1: form.oldEmailVerificationCode || '',
    code2: form.newEmailVerificationCode || '',
    verificationId1: form.oldEmailVerificationId,
    verificationId2: form.newEmailVerificationId
  })

  if (!data.ok) {
    yield put(actions.form.change(formName.CHANGE_EMAIL, 'loading', false))
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.auth.getUser())
  yield put(actions.app.hideModal('CHANGE_EMAIL'))
}

export default function* changeEmailMain() {
  yield takeEvery(actionTypes.changeEmail.SUBMIT, submit)
}
